export default __webpack_public_path__ + "static/media/AdanceSet.5d5491a4.png";